import { useEffect, useRef } from "react";
import { useStore } from "../../store/store";
import { fetchPublicLiveFiles } from "../api/liveFiles";

/**
 * Loads published live files (GET /live/file-live/:liveId) into the store so
 * the Documents tab visibility and list match the API before socket updates.
 */
export function usePublicLiveFilesBootstrap(liveId: number | undefined) {
	const setPublicLiveFiles = useStore((s) => s.setPublicLiveFiles);
	const prevLiveId = useRef<number | undefined>(undefined);

	useEffect(() => {
		if (liveId == null) {
			return;
		}
		if (prevLiveId.current !== liveId) {
			prevLiveId.current = liveId;
			setPublicLiveFiles([]);
		}
		let cancelled = false;
		fetchPublicLiveFiles(liveId)
			.then((files) => {
				if (!cancelled) {
					setPublicLiveFiles(files);
				}
			})
			.catch(() => {
				if (!cancelled) {
					setPublicLiveFiles([]);
				}
			});
		return () => {
			cancelled = true;
		};
	}, [liveId, setPublicLiveFiles]);
}
